import React, { useState, useEffect, Fragment } from 'react';

import './other.css'

export default function Noaccred(props) {


    return (
        <div className="center">
            <h2>Personne non accréditée sur ce créneau</h2>
        </div>
    );
}